import {Component} from '@angular/core';
import {FieldType, FieldTypeConfig, FormlyModule} from '@ngx-formly/core';

import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {IonCol, IonItem, IonRow, IonText} from '@ionic/angular/standalone';

@Component({
  selector: 'textarea-formly-type',
  styles: `
    .upload {
      padding-top: 100%;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .upload button {
      outline: var(--ion-color-medium) dashed 1px;
      outline-offset: -1px;
      background: transparent;
      color: var(--ion-color-dark);
      border-radius: 8px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: outline-color 100ms;
    }

    .upload button ion-icon {
      font-size: 40px;
      color: var(--ion-color-medium);
      padding: 16px;
      transition: color 100ms;
    }

    .upload button:hover {
      outline: var(--ion-color-primary) dashed 1px;
    }

    .upload button:hover ion-icon {
      color: var(--ion-color-primary);
    }`,
  template: `
    <div>
      <ion-item style="cursor: unset; --background-hover-opacity: 0;" lines="full">
        <div style="width: 100%; padding-top: 8px;">
          <ion-text [color]="showError && formControl.errors ? 'danger': ''">
            {{ props.label }}
            <ion-text color="medium">
            </ion-text>
            @if (props.description) {
              <button style="background: none; margin-left: 8px;">ⓘ</button>
            }
          </ion-text>

          <ion-row>
            <ion-col size-xs="3" size-sm="3" size-md="3" size-lg="2" size-xl="1">
              <div class="upload">
                <button>
                  <img style="max-width: 40px;" src="images/logo-trimble.png" [alt]="'Trimble meetstok' | translate">
                </button>
              </div>
              <ion-text>
                <small>
                  Meetstok (Trimble)
                </small>
              </ion-text>
            </ion-col>
            <ion-col size-xs="3" size-sm="3" size-md="3" size-lg="2" size-xl="1">
              <div class="upload">
                <button>
                  <img style="max-width: 40px;" src="images/logo-scanxact.png" [alt]="'Trimble meetstok' | translate">
                </button>
              </div>
              <ion-text>
                <small>
                  LiDAR (ScanXact)
                </small>
              </ion-text>
            </ion-col>
          </ion-row>
        </div>
      </ion-item>
    </div>
  `,
  imports: [TranslateModule, FormlyModule, ReactiveFormsModule, IonItem, IonText, IonCol, IonRow]
})
export class T4EMeasurementMethodFormlyType extends FieldType<FieldTypeConfig> {
}
